import { createContext, useContext, useMemo } from 'react';

const EnvironmentVariablesContext = createContext<{
  mndAssets: {
    apiKey: string;
    cdnDistribution: string;
    postUrl: string;
    preset: string;
  };
}>({
  mndAssets: {
    apiKey: '',
    cdnDistribution: '',
    postUrl: '',
    preset: '',
  },
});

export const EnvironmentVariablesContextProvider = ({
  mndAssets,
  children,
}: {
  mndAssets:
    | {
        apiKey: string;
        cdnDistribution: string;
        postUrl: string;
        preset: string;
      }
    | undefined;
  children: React.ReactNode;
}) => {
  return (
    <EnvironmentVariablesContext.Provider
      value={useMemo(
        () => ({
          mndAssets: mndAssets || {
            apiKey: '',
            cdnDistribution: '',
            postUrl: '',
            preset: '',
          },
        }),
        [mndAssets],
      )}
    >
      {children}
    </EnvironmentVariablesContext.Provider>
  );
};

export const useEnvironmentVariables = () => useContext(EnvironmentVariablesContext);
